import type { Logger } from '@vp/ubik-logging';
import type { Identity } from '../../auth/useOnUserIdentityUpdate';

export async function fetchLogomationSessionId(
    identity: Identity,
    logger: Logger,
    logomationBaseUrl: string,
): Promise<string> {
    // Reuse last Logomation session ID if one exists
    // This aims to reduce the throttling issues outlined in
    // https://vistaprint.atlassian.net/wiki/spaces/LMCC/pages/4516708634/Dynamodb+Issue+Write+Throttling+of+SessionConfig
    const existingSsid = localStorage.getItem('logomakerAnywhereLogomationSessionId');
    if (existingSsid) {
        return existingSsid;
    }

    try {
        const response = await fetch(
            `${logomationBaseUrl}/v1/session/create?cookie=false&tenant=logomaker_anywhere`,
            {
                headers: {
                    Authorization: `Bearer ${identity.accessToken}`,
                },
            },
        );
        const responseBody = await response.json();
        return responseBody.message;
    } catch (error) {
        logger.error({
            name: 'Logomaker Anywhere: Failed to create logomation session',
            message: (error as Error).message,
        });
        return '';
    }
}
